// Order of import is important
import { $ } from 'bits/jquery'
import 'jquery-ui/ui/widgets/sortable'
import 'vendor/jquery.ui.touch-punch'
export { $ }
